import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link,NavLink  } from 'react-router-dom';
import { IntrigrationLeftSec } from '../components/intrigrationLeftSec';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import ScrollToTop from "react-scroll-to-top";
import config from '../Config';
import {CopyToClipboard} from 'react-copy-to-clipboard';

export const AchCountry = () => {
            const onCopy = React.useCallback((id:number) => {
                const element = document.getElementById("myTooltip"+id);
                if (element) {
                  element.classList.add("show");
                  const intervalId = setInterval(() => {
                    element.classList.remove("show");
                    clearInterval(intervalId);
                  }, 2000);
                }
              }, []);
        
          return (
            <section className="credit-api-main">
            <img src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bg.svg`} alt="Dots" className='apibg' />
              <div className="container">
                  <div className="row">
                      <div className="col-lg-3">
                          <IntrigrationLeftSec />
                      </div>
                      <div className="col-lg-9">
                          <div className="creadit-api-upper-wrapper">
                                <Link to="/integrations" className='apidetail-btn'><FontAwesomeIcon icon={faArrowRight} /> Return to Integrations page</Link>
                              {/* <h2>ACH API</h2>
                              <ul className="card-url">
                                  <li>
                                      <div className="card-url-list">
                                           <p>URL To Call: </p>
                                           <span><Link to=''>{config.gatewayApisUrlSand}/apis/ach_sale.php</Link></span>
                                      </div>
                                    
                                  </li>
                                  
                                  <li>
                                      <div className="card-url-list">
                                          <p>Example:</p>
                                          <span><Link to=''>{config.gatewayApisUrlSand}/apis/sale.php</Link></span>
                                      </div>
                                  </li>
                                  <li>
                                      <div className="card-url-list">
                                          <p>Production endpoint URL:</p>
                                          <span><Link to=''>{`${config.gatewayApisUrlProd}/apis/{method}`}</Link></span>
                                      </div>
                                  </li>
                              </ul> */}
                          </div>
        
                          <div className="creadit-api-lower-wrapper">
                              <div className="api-menu-item-title">
                                  <h1>ACH</h1>
                              </div>
                              <div className="api-menu-item-wrapper">
                                  <h3>Country List</h3>
                                  <hr />
                              </div>
                          </div>
        
                          <div className="api-table">
                              <div className="table-responsive">   
                                <table summary="The table describes the request parameters to perform a sale." className="table table-striped table-bordered table-hover">
                                    <thead>
                                        <tr>
                                        <th>Country Code</th>
                                        <th>Country Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td>US</td>
                                        <td>United States</td>
                                        </tr>
                                        <tr>
                                        <td>CA</td>
                                        <td>Canada</td>
                                        </tr>
                                    </tbody>
                                </table>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <img src={`${config.siteBaseUrl}/assets/imgs/blue-lowerdots.svg`}  alt="Dots" className="orng-dots" />
              <ScrollToTop smooth />
            </section>
          )
}    
